<template>
  <div
    id="navigation"
    @mouseover="showSubnavToggle"
    @mouseleave="hideSubnavToggle"
  >
    <Navbar id="navbar" :expanded="expanded" />
    <Subnav
      id="subnav"
      :class="{ 'subnav--active': showSubNavigationColumn }"
    />
    <div
      v-if="baseRoute != 'contentGenerationV2'"
      class="subnav__toggle"
      :class="{
        'subnav__toggle--expanded': expanded,
        'subnav__toggle--active': showNav,
        show: showToggleButton
      }"
      @click="onClick"
    >
      <i class="fas fa-chevron-left toggle__icon" />
    </div>
  </div>
</template>
<script setup>
import Navbar from '@/components/navbar/Navbar'
import Subnav from '@/components/navbar/Subnav'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const props = defineProps({
  expanded: Boolean
})

const onToggle = ref(true)
const showToggleButton = ref(false)

const showNav = computed(() => store.state.navigation.showNav)
const baseRoute = computed(() => store.state.navigation.baseRoute)
const showSubnav = computed(() => store.getters['navigation/showSubnav'])
const showSubNavigationColumn = computed(
  () => showNav.value && showSubnav.value
)

const showSubNavigation = (payload) =>
  store.commit('navigation/showSubNavigation', payload)

function onClick() {
  const toggle = (onToggle.value = !showNav.value)
  showSubNavigation(toggle)
}
function showSubnavToggle() {
  showToggleButton.value = true
}
function hideSubnavToggle() {
  showToggleButton.value = false
}
</script>
<style lang="scss">
.subnav__toggle {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  top: 70px;
  left: 50px;
  background: $white;
  box-shadow: 0px 1px 3px #15174a29;
  display: none;
  &.show {
    display: initial;
  }
  .toggle__icon {
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(180deg);
    color: $black-50;
    z-index: 1;
  }
  &:hover {
    background: $black-10;
    .toggle__icon {
      color: $black-80;
    }
  }
  &--expanded {
    left: 238px;
  }
  &--active {
    right: -10px;
    left: 238px;
    .toggle__icon {
      transform: translate(-50%, -50%) rotate(0deg);
    }
  }
}
</style>
